import EditLocalAdmin from './EditLocalAdmin';

export default EditLocalAdmin;
